export const tableColumns = [
  {
    label: "姓名",
    prop: "name",
    width: "120",
    fixed: "left",
    contentAlign: "left"
  },
  {
    label: "状态",
    prop: "status",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "手机号/邮箱",
    prop: "telephone",
    width: "120",
    contentAlign: "center"
  },
  {
    label: "部门",
    prop: "companyScope.departmentNames",
    width: "120",
    contentAlign: "center"
  },
  {
    label: "职位",
    prop: "companyScope.position",
    width: "120",
    contentAlign: "center"
  },
  {
    label: "汇报对象",
    prop: "companyScope.superiorName",
    width: "120",
    contentAlign: "center"
  },
  {
    label: "企业角色",
    prop: "role",
    width: "150",
    contentAlign: "center"
  },
  {
    label: "最后使用时间",
    prop: "lastReqTime",
    width: "150",
    contentAlign: "center"
  }
]

export const searchableInfos = [
  {
    label: "姓名",
    value: "name"
  },
  {
    label: "手机号",
    value: "telephone"
  },
  {
    label: "角色",
    value: "companyRoleName"
  },
  {
    label: "状态",
    value: "status"
  }
]

export const status = ["正常", "已停用", "未激活"]
